

import { z } from "zod";


export const ApiResponseSchema = <T extends Record<string, z.ZodType>>(responseData: T) => z.object({
  status: z.string().default(""),
  message: z.string().optional(),
  ...responseData
})

export type ApiResponseType<T extends Record<string, z.ZodType>> = z.infer<ReturnType<typeof ApiResponseSchema<T>>>;

